export default __webpack_public_path__ + "static/Home-83bc1951156fd21946f58403d373d784.svg";